import React, { useEffect, useState } from "react";
import FormComponent from "./FormComponent";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { Form } from "antd";
import { updateSIM } from "../../../../store/SIMManagementSlice";

const EditComponent: React.FC<any> = (props) => {
  const { visible, close, editData, getList } = props;
  const [form] = Form.useForm();
  const [check, setCheck] = useState(true);
  const dispatch: AppDispatch = useDispatch();
  const handleSubmit = (data: any) => {
    data.id = editData._id;
    dispatch(updateSIM(data))
      .then(() => {
        getList();
        handleClose();
        form.resetFields();
      })
      .catch((e: any) => {
        console.warn(e);
      });
  };

  const handleClose = () => {
    setCheck(true);
    close();
    form.resetFields();
  };

  useEffect(() => {
    if (visible && editData) {
      if (editData?.status) {
        setCheck(true);
      } else {
        setCheck(false);
      }
      form.setFieldsValue({
        ...editData,
      });
    }
  }, [editData, form, visible]);

  return (
    <>
      <FormComponent
        handleSubmit={handleSubmit}
        form={form}
        visible={visible}
        close={handleClose}
        title={"Edit SIM Management"}
        check={check}
        setCheck={setCheck}
        type={"Edit"}
      />
    </>
  );
};

export default EditComponent;
